import {useCallback, useEffect, useState} from 'react';
import {fetchChartRequirements} from '../firebase/firestore/whiteboards';

/**
 * ICRs linked to a chart via icr_associations (same rows as ICR > Linked Items > Chart).
 */
export function useChartRequirements(whiteboardId, enabled = true) {
    const [requirements, setRequirements] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const refetch = useCallback(async () => {
        if (!whiteboardId || !enabled) {
            setRequirements([]);
            setLoading(false);
            setError(null);
            return;
        }

        setLoading(true);
        setError(null);
        try {
            const rows = await fetchChartRequirements(whiteboardId);
            setRequirements(Array.isArray(rows) ? rows : []);
        } catch (err) {
            setRequirements([]);
            setError(err instanceof Error ? err : new Error('Failed to load requirements.'));
        } finally {
            setLoading(false);
        }
    }, [whiteboardId, enabled]);

    useEffect(() => {
        refetch();
    }, [refetch]);

    return {
        requirements,
        loading,
        error,
        refetch,
        count: requirements.length,
    };
}

export default useChartRequirements;
